// extracted by mini-css-extract-plugin
export default {"scrollUp":"ScrollUp_scrollUp__t7k+W"};